import { log } from 'utils/console';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import exposeHostAppNamespace from 'common/utils/hostApp';

import './styles.styl';

const NAME = 'mobile-rsvp';

function logMobileRsvp(...args) {
    log(`[${NAME}]`, ...args);
}

/**
 * Force .cms-form-container's parent element to be a
 * child element of #g-1 container
 *
 * Why?
 *
 * Because we have no way of knowing the DOM structure of the
 * Mobile RSVP Form partial render.
 *
 * A form nested inside a Modal will have different qualities
 * from a form directly in the event body.
 *
 * This normalizes the display behavior of the form a little bit
 *
 * @return {void}
 */

function forceFormContainerToChildOfG1() {
    const form = document.querySelector('.cms-form-container'); // Get the form
    const g1 = document.querySelector('#g-1'); // This is always there for some reason!
    if (g1 && form) {
        g1.appendChild(form);
    }
}

export default function initialize() {
    const bootstrap = getBootstrap();
    const isEnabled = bootstrap.get('mobileRsvp.initializeMobileRsvp');

    logMobileRsvp('initialize', isEnabled);

    if (isEnabled) {
        exposeHostAppNamespace();
        forceFormContainerToChildOfG1();
        document.querySelector('body').className += ' mobile-rsvp';
    }
}
